/**
 * 
 * @type {Record<"pingData" | "errorData",
 * (Partial<Omit<import('@ag-grid-community/core').ColDef, 'valueFormatter'>>
 *  & ({
 *      headerName: keyof typeof import('./locales').default.en
 *      field: (data.structures.rateLimitData)
 *      valueFormatter?: (({value: any}) => any) | undefined
 *      tooltipText?: keyof typeof import('./locales').default.en
 *     })
 * )[]>}
 */
export const columnSettings = {
  rateLimitData: [
    {
      headerName: 'RATE_LIMITS_TABLE_HEADER_NAME',
      field: 'rateLimitsName'
    },
    {
      headerName: 'RATE_LIMITS_TABLE_HEADER_EMAIL',
      field: 'rateLimitsEmail',
    },
    {
      headerName: 'RATE_LIMITS_TABLE_HEADER_ROLE',
      field: 'rateLimitsRole',
    },
    ],
    extraData: [
      {
        headerName: 'RATE_LIMITS_TABLE_SUBHEADER_PATH_PATTERN',
        field: 'rateLimitsPathPattern',
      },
      {
        headerName: 'RATE_LIMITS_TABLE_SUBHEADER_LIMIT',
        field: 'rateLimitsLimit',
      },
      {
        headerName: 'RATE_LIMITS_TABLE_SUBHEADER_METHOD',
        field: 'rateLimitsMethod',
      },
      {
        headerName: 'RATE_LIMITS_TABLE_SUBHEADER_PERIOD',
        field: 'rateLimitsPeriod',
      }
  ]
};


export const rateLimitsColumnSettings = columnSettings.rateLimitData;
export const extraColumnSettings = columnSettings.extraData;
